<template>
  <div class="d-bank _purchase" :class="{_hidden: !item.active, _first: item.first}">
    <div class="d-bank__item _item1">
      <img class="d-bank__logo" :src="item.logo">
    </div>
    <!--<div v-if="item.first" class="d-bank__item _item1">
      <img class="d-bank__logo" :src="item.logo">
    </div>
    <div v-else class="d-bank__item" />-->
    <div v-if="item.first" class="d-bank__item _program">
      {{ count }}
      <div class="d-bank__name">{{ item.bank }}</div>
    </div>
    <div v-else class="d-bank__item _program">
      {{ item.type.name }}
      <div class="d-bank__name">{{ item.name }}</div>
    </div>
    <div v-if="item.percent_second || item.first" class="d-bank__item _item3">
      <div class="d-bank__label">Ставка</div>
      от {{ item.percent }}%
    </div>
    <div v-else class="d-bank__item _item3">
      <div class="d-bank__label">Ставка</div>
      {{ item.percent }}%
    </div>
    <div class="d-bank__item _item4">
      <div class="d-bank__label">Первонач. взнос</div>
      от {{ item.initial }}%
    </div>
    <div class="d-bank__item _item5">
      <div class="d-bank__label">Срок</div>
      до {{ item.time }}
    </div>
    <div v-if="item.percent_second || item.first" class="d-bank__item _item6">
      <div class="d-bank__label">Платеж в&nbsp;месяц</div>
      от {{ formatMoney(item.payment) }} ₽
    </div>
    <div v-else class="d-bank__item _item6">
      <div class="d-bank__label">Платеж в&nbsp;месяц</div>
      {{ formatMoney(item.payment) }} ₽
    </div>
    <div class="d-bank__item _item7">
        <button v-if="item.first"
                class="d-button _dark"
                @click="$emit('showBank')">
          <span>Показать</span>
        </button>
        <button v-else
                class="d-button _blue"
                @click="$emit('openForm')">
          <span>Подробнее</span>
        </button>
    </div>
    <button v-if="!item.first" class="d-bank__button" @click="$emit('openForm')"/>
    <button v-else class="d-bank__button" @click="$emit('showBank')"/>
  </div>
</template>

<script>
export default {
  name: 'DMortgageItem',
  props: {
    count: String,
    item: Object,
  },
  methods: {
    formatMoney(value) {
      if (!value) return value;
      if (typeof value === 'number') {
        return new Intl.NumberFormat('en-US', {
          style: 'decimal',
          useGrouping: true,
          maximumSignificantDigits: 11,
        })
            .format(value)
            .replace(/[ ,]/g, ' ');
      }
      else {
        return value;
      }
    },
  }
};
</script>
